const styles = () => ({
	rootInput: {
		width: "288px",
	},
	disabled: {
		opacity: ".6",
	},
	dateIconClass: {
		width: "22px",
		marginLeft: "4px",
	},
	widthAuto: {
		width: "auto !important",
	},
});

export default styles;
